<template>
  <div
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
    v-if="avulso"
  >

    <ed-modal
      title="INSERIR NOVO RISCO"
      :modal="showProcedimento"
      :onSave="inserirProcedimento"
      :isModal="false"
      width="50%"
    >
      <div slot="modal-content">
        <ed-input-auto-complete
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0"
          label="Pesquisar risco"
          v-model="bind.procedimento"
          :items="bind.procedimentos"
          :loading="bind.loadingProcedimento"
          @search="getRisco"
          clearable
          is-object
        />
      </div>
    </ed-modal>

    <div class="item-group mt-2">
      Informações sobre as atividades
    </div>

    <div class="row">
      <ed-input-date
        class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="Início das Atividades"
        v-model="formData.ambiente.dtIniCondicao"
        name="valor.ambiente.dtIniCondicao"
        required
      />

      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9"
        label="Descrição das Atividades"
        v-model="formData.ambiente.dscAtivDes"
        name="valor.Atividades"
        required
      />
    </div>

    <div class="item-group mt-2">
      Informações relativas ao responsável pelos registros ambientais.
    </div>

    <div class="row">
      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="Nome do Responsavel"
        v-model="formData.responsavel.nome"
        name="valor.responsavel.nome"
        required
      />

      <ed-input-text
      class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="CPF do Responsavel"
        v-model="formData.responsavel.cpfResp"
        name="valor.responsavel.cpfResp"
        required
      />

      <ed-input-select
      class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="Órgão de Classe"
        :items="[
          { id: 1, nome: 'Conselho Regional de Medicina - CRM' },
          { id: 4, nome: 'Conselho Regional de Engenharia e Agronomia - CREA' },
          { id: 9, nome: 'Outros' },
        ]"
        v-model="formData.responsavel.ideOC"
        name="valor.responsavel.ideOC"
      />

      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="Número de Incrição de Classe"
        v-model="formData.responsavel.nrOC"
        name="valor.responsavel.nrOC"
        type="number"
        required
      />


      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="Unidade Federativa"
        name="valor.responsavel.ufOC"
        :items="parent.bind.estados"
        v-model="formData.responsavel.ufOC"
        required
      />
    </div>

    <div class="item-group mt-2">
      Agente(s) nocivo(s) ao(s) qual(is) o trabalhador está exposto. - Tabela 24
      do eSocial
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <ed-button
          icon="fa fa-plus-circle"
          type="success"
          label="Inserir Novo Risco"
          title="Inserir Novo Risco"
          @click="showProcedimento = !showProcedimento"
        />

        <b-table-simple
          id="table-v0"
          class="col-12 table-v2 mt-1"
          small
          outlined
          borered
        >
          <b-thead>
            <b-tr>
              <b-th width="150">CÓDIGO</b-th>
              <b-th>RISCO</b-th>
              <b-th>DESCRIÇÃO</b-th>
              <b-th>TIPO DE AVALIAÇÃO</b-th>
              <b-th>INTENSIDADE OU CONCENTRAÇÃO</b-th>
              <b-th>LIMITE DE TOLERÂNCIA</b-th>
              <b-th>UNIDADE DE MEDIDA</b-th>
              <b-th width="150"></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-if="!formData.riscos.length">
              <b-td colspan="5" align="center"> Nenhum risco cadastrado </b-td>
            </b-tr>
            <b-tr v-for="(risco, index) in formData.riscos" :key="index">
              <b-td>
                {{ risco.codigo }}
              </b-td>
              <b-td>
                {{ risco.nome }}
              </b-td>
              <b-td>
                <ed-input-text
                  style="with:100%"
                  v-model="risco.dscAgNoc"
                  :key="'dscAgNoc-'+index"
                />
              </b-td>
              <b-td>
                <ed-input-select
                  style="with:100%"
                  :items="[
                    { id: 1, nome: 'Critério quantitativo' },
                    { id: 2, nome: 'Critério qualitativo' },
                  ]"
                  v-model="risco.tpAval"
                  :key="'tpAval-'+index"
                />
              </b-td>
              <b-td>
                <ed-input-text
                  style="with:100%"
                  v-model="risco.intConc"
                  v-mask="'money'"
                  :key="'intConc-'+index"
                />
              </b-td>
              <b-td>
                <ed-input-text
                  style="with:100%"
                  v-model="risco.limTol"
                  v-mask="'money'"
                  :key="'limTol-'+index"
                />
              </b-td>
              <b-td>
                <ed-input-select
                  style="with:100%"
                  :items="[
                    { id: 1, nome: 'dose diária de ruído' },
                    { id: 2, nome: 'decibel linear (dB (linear))' },
                    { id: 3, nome: 'decibel (C) (dB(C))' },
                    { id: 4, nome: 'decibel (A) (dB(A))' },
                    { id: 5, nome: 'metro por segundo ao quadrado (m/s2)' },
                    { id: 6, nome: 'metro por segundo elevado a 1,75 (m/s1,75)' },
                    { id: 7, nome: 'parte de vapor ou gás por milhão de partes de ar contaminado (ppm)' },
                    { id: 8, nome: 'miligrama por metro cúbico de ar (mg/m3)' },
                    { id: 9, nome: 'fibra por centímetro cúbico (f/cm3)' },
                    { id: 10, nome: 'grau Celsius (ºC)' },
                    { id: 11, nome: 'metro por segundo (m/s)' },
                    { id: 12, nome: 'porcentual' },
                    { id: 13, nome: 'lux (lx)' },
                    { id: 14, nome: 'unidade formadora de colônias por metro cúbico (ufc/m3)' },
                    { id: 15, nome: 'dose diária' },
                    { id: 16, nome: 'dose mensal' },
                    { id: 17, nome: 'dose trimestral' },
                    { id: 18, nome: 'dose anual' },
                    { id: 19, nome: 'watt por metro quadrado (W/m2)' },
                    { id: 20, nome: 'ampère por metro (A/m)' },
                    { id: 21, nome: 'militesla (mT)' },
                    { id: 22, nome: 'microtesla (μT)' },
                    { id: 23, nome: 'miliampère (mA)' },
                    { id: 24, nome: 'quilovolt por metro (kV/m)' },
                    { id: 25, nome: 'volt por metro (V/m)' },
                    { id: 26, nome: 'joule por metro quadrado (J/m2)' },
                    { id: 27, nome: 'milijoule por centímetro quadrado (mJ/cm2)' },
                    { id: 28, nome: ' milisievert (mSv)' },
                    { id: 29, nome: 'milhão de partículas por decímetro cúbico (mppdc)' },
                    { id: 30, nome: 'umidade relativa do ar (UR (%))' },

                  ]"
                  v-model="risco.unMed"
                  :required="risco.tpAval == 1"
                  :key="'unMed-'+index"
                />
              </b-td>
              <b-td>
                <ed-button
                  icon="fa fa-trash"
                  type="danger"
                  title="Remover Novo risco"
                  @click="removerProcedimento(index)"
                />
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
  </div>
</template>

<script>
import Fct from "common/fct";
import {
  EdButton,
  EdInputText,
  EdInputDate,
  EdInputAutoComplete,
  EdInputSelect,
  EdInputSelectTipo,
  EdModal,
} from "template";

export default {
  name: "esocial-s2240",
  mixins: [Fct],
  components: {
    EdButton,
    EdInputText,
    EdInputDate,
    EdInputAutoComplete,
    EdInputSelect,
    EdInputSelectTipo,
    EdModal,
  },

  props: {
    avulso: {
      type: Number,
      default: 0,
    },
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    parent: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  watch: {
    "parent.response"() {
      this.formataLista();
    },
  },

  data() {
    return {
      bind: {
        procedimento: null,
        procedimentos: [],
        loadingProcedimento: false,
      },
      showProcedimento: false,
      tableHead: [
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          show_empresa_link: true,
          label: "Empresa",
        },
        {
          key: "funcionario",
          sortable: true,
          show_funcao: true,
          show_funcionario_link: true,
          label: "Funcionário",
        },
        {
          key: "consulta",
          sortable: true,
          show_consulta_link: true,
          label: "Consulta",
        },
        {
          key: "pgr",
          sortable: true,
          label: "PPRA/PGR",
        },
        {
          key: "ghe",
          sortable: true,
          label: "GHE (SETOR)",
        },
        {
          key: "recibo",
          sortable: true,
          label: "Recibo",
        },
        {
          key: "lote",
          sortable: true,
          label: "Lote",
        },
        {
          key: "tipo_status",
          sortable: true,
          label: "Status",
        },
        {
          key: "updated_at",
          sortable: true,
          show_user: true,
          label: "Atualização",
        },
      ],
    };
  },

  mounted() {
    if (!this.avulso) {
      this.formataLista();
    } else {
      this.getRisco();
    }
  },

  methods: {
    inserirProcedimento() {

      if (this.bind.procedimento) {
        let encontrado = false;

        this.formData.riscos.forEach((element) => {
          if (element.codigo == this.bind.procedimento.codigo) {
            encontrado = true;
          }
        });

        if (encontrado) {
          this.$root.$dialog.alert("Procedimento já foi inserido", "warning");
          return;
        }

        this.formData.riscos.push({
          codigo: this.bind.procedimento.codigo,
          nome: this.bind.procedimento.nome,
          dscAgNoc: null,
          tpAval: 1,
          intConc:null,
          limTol:null,
          unMed:null,
          tecMedicao:null
        });
        this.showProcedimento = !this.showProcedimento;
      }
    },

    removerProcedimento(index) {
      this.formData.riscos.splice(index, 1);
      this.$forceUpdate()
    },

    getRisco(_search) {
      this.bind.procedimentos = [];
      this.bind.loadingProcedimento = false;

      this.$root.$request
        .get("esocial/tabelas/conteudo/24", {
          search: _search,
          pagination: 100,
        })
        .then((result) => {
          this.bind.loadingProcedimento = false;

          if (result.status == 200) {
            result.data.data.forEach((element) => {
              let item = {
                id: element.id,
                codigo: element.codigo,
                nome: element.codigo + " - " + element.nome,
              };

              if (item.nome.length > 50) {
                item.nome = item.nome.substring(0, 100);
              }

              this.bind.procedimentos.push(item);
            });
          }
        });
    },

    formataLista: function () {
      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
        arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        console.log('i '+i)
        
        arrData[i]._nome =
          arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao
          ? arrData[i].funcionario.funcao
          : null;
        arrData[i].fdt = arrData[i].funcionario.fdt
          ? arrData[i].funcionario.fdt
          : null;
        arrData[i].ghe = arrData[i].ghe ? arrData[i].ghe : null;

        let pgr = "";
        let lote = "";

        if (arrData[i].ghe && arrData[i].ghe.revisao) {
          pgr =
            arrData[i].ghe.revisao.rev +
            " (" +
            arrData[i].ghe.revisao.descricao +
            ")";

          if (arrData[i].ghe.revisao.parent) {
            pgr +=
              " / " +
              arrData[i].ghe.revisao.parent.rev +
              " (" +
              arrData[i].ghe.revisao.parent.descricao +
              ")";
          }

          pgr =
            '<a target="_blank" href="' +
            this.$root.$session.env.url_cs +
            "/app/ppra.php?emp=" +
            arrData[i].empresa.id +
            "&pcmso=" +
            (arrData[i].funcionario  && arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt.id  : '')+
            "&rev=" +
            (arrData[i].ghe && arrData[i].ghe.revisao ? arrData[i].ghe.revisao.id : '') +
            "&ghe=" +
            (arrData[i].ghe  ? arrData[i].ghe.id  : '') +
            '" arget="_blank">' +
            pgr +
            "</a>";
        }

        if (arrData[i].lote) {
          lote = '<a target="_blank" href="/esocial/lotes/' + arrData[i].lote + '">';
          lote +=
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '"><i class="fa fa-plus"></i> Lote inclusão ' +
            arrData[i].lote +
            "</span>";
          lote += "</a>";
        }

        if (arrData[i].lote_exclusao) {
          lote +=
            '<br><a target="_blank" href="/esocial/lotes/' +
            arrData[i].lote_exclusao +
            '">';
          lote +=
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '"><i class="fa fa-times"></i> Lote exclusão ' +
            arrData[i].lote_exclusao +
            "</span>";
          lote += "</a>";
        }

        var item = {
          consulta: arrData[i].id_con ? arrData[i].id_con : "---",
          pgr: pgr,
          empresa: arrData[i].empresa.nome,
          ghe:
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '">' +
            (arrData[i].ghe
              ? arrData[i].ghe.ghe + " (" + arrData[i].ghe.descricao.trim() + ")"
              : "---") +
            "</span>",
          funcionario: arrData[i].funcionario.nome,
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao: null,
          id: arrData[i].id,
          lote: lote ? lote : "---",
          recibo:
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '">' +
            (arrData[i].recibo ? arrData[i].recibo : "---") +
            "</span>",
          updated_at:
            '<span style="color:' +
            (
            arrData[i].tipo_status && arrData[i].tipo_status.id === 380
              ? "orange"
              : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
          ) +
            '">' +
            this.toDate(arrData[i].updated_at, false) +
            "</span>",
          dt_cad:
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '">' +
            this.toDate(arrData[i].created_at, false) +
            "</span>",
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          tipo_status:
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '">' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.descricao: null) +
            "</span>",
          fdt: arrData[i].fdt,
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete:
              arrData[i].tipo_status &&
              [332, 330].indexOf(arrData[i].tipo_status.id) != -1 &&
              arrData[i].recibo &&
              this.$root.$session.validarPermissao(586)
                ? false
                : true,
          },
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Gerar arquivo XML",
            style: "color:#e03a3a",
            click: this.parent.onEdit,
          });
        } else {

          item.buttons.push({
            icon: "fa fa-pen",
            color: "default",
            title: "Atualizar dados do evento",
            style: "color:#34c142",
            click: this.parent.onUpdateUid,
          });
          
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML,
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote,
            });
          }

          if (!arrData[i].recibo && arrData[i].tipo_status.id != 380) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit,
            });
          }

          if (
            arrData[i].recibo &&
            arrData[i].tipo_status &&
            [332, 335].indexOf(arrData[i].tipo_status.id) != -1
          ) {
            item.buttons.push({
              icon: "fa fa-times-circle",
              color: "default",
              title: "Excluir arquivo XML",
              style: "color:#d82d2d",
              click: this.parent.onDelete,
            });
          }
        }

        //LOGS
        if (arrData[i].log_erro.length || arrData[i].log_warning.length) {
          item.buttons.push({
            icon: "fa fa-exclamation-triangle faa-flash animated",
            color: "default",
            title:
              item._data.log_erro.length +
              item._data.log_warning.length +
              " conflito(s) encontrado(s)",
            style: "color:" + (arrData[i].log_erro.length ? "red" : "#ff8300"),
            click: this.parent.onLogs,
          });
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// s2240.vue?e97e860e